<script setup>
import { useI18n } from '@/i18n'
const { t } = useI18n()
</script>

<template>
        <footer style="padding: 20px 0; text-align: center;">
            <div>
                <pDivider />
                <p>{{ t('footer.tagline') }}</p>

            </div>
        </footer>
</template>

